import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';

// Where Back goes when there is no in-app page to return to — e.g. a page opened
// in a new tab from a list (Edit Booking, Edit Workstation) or reloaded/bookmarked.
// First matching path prefix wins.
const PARENT_ROUTES = [
  ['/editBooking/', '/slotBooking'],
  ['/workstationedit/', '/workstationview'],
  ['/consent', '/workstationview'],
  ['/editquote/', '/viewquote'],
  ['/quoteInvoice', '/viewquote'],
  ['/viewComplaints', '/complaints'],
  ['/addComplaints', '/complaints'],
  ['/editExpense', '/expense'],
  ['/inspectionDetail/', '/inspection'],
  ['/editService', '/viewservices'],
  ['/addsale', '/viewsale'],
  ['/editsale/', '/viewsale'],
  ['/viewsale', '/storelist'],
  ['/addproduct', '/storelist'],
  ['/editproduct/', '/storelist'],
  ['/allcars', '/storelist'],
  ['/brands', '/storelist'],
];

export const parentRouteFor = (pathname) => {
  const match = PARENT_ROUTES.find(([prefix]) => pathname.toLowerCase().startsWith(prefix.toLowerCase()));
  return match ? match[1] : '/dashboard';
};

const BackButton = ({ fallback }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goBack = () => {
    // React Router records the position in its own history stack; 0 means this
    // page was the first one loaded in the tab, so navigate(-1) would leave the
    // app (or do nothing).
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback || parentRouteFor(pathname), { replace: true });
    }
  };

  return (
    <button
      type="button"
      className="btn btn-link p-0 back-arrow-btn"
      title="Go Back"
      aria-label="Go Back"
      onClick={goBack}
    >
      <ArrowLeft size={20} className="text-primary back-arrow" />
    </button>
  );
};

BackButton.propTypes = {
  fallback: PropTypes.string,
};

export default BackButton;
